/** @format */

export function isObject(variable: any) {
    return (
        typeof variable === 'object' &&
        variable !== null &&
        !Array.isArray(variable)
    );
}
